import { actionCopyEs } from "./actionCopy";
import { listCopyEs } from "./listCopy";

export const studiesCopyEs = {
    studies: "Estudios",
    description: "Cree estudios e invite a clínicos con accesos, etiquetas y una facturación obtenidos de los modelos.",
    unauthorizedMessage: "Los estudios están reservados a los administradores y a los responsables.",
    searchPlaceholder: "Buscar estudios, etiquetas, formularios o modelos",
    searchAriaLabel: "Buscar estudios",
    clearSearchAria: actionCopyEs.clearSearch,
    filterStudiesAria: "Filtrar los estudios",
    studyFilterDescription: "Filtre los estudios por estado y por plan de facturación.",
    newStudy: "Nuevo estudio",
    noStudiesYet:
        "Ningún estudio por el momento. Cree su primer estudio para configurar los accesos y las invitaciones.",
    noStudiesMatchSearch: "Ningún estudio coincide con su búsqueda o sus filtros.",
    columnStudyName: "Nombre del estudio",
    columnLabel: "Etiqueta",
    columnForms: "Formularios",
    columnTemplates: "Modelos",
    columnPlan: "Plan",
    columnExpiry: "Vencimiento",
    columnDiaries: "Diarios",
    columnClinicians: "Clínicos",
    columnStatus: listCopyEs.status,
    columnActions: listCopyEs.actions,
    published: listCopyEs.published,
    draft: listCopyEs.draft,
    open: actionCopyEs.open,
    invite: actionCopyEs.invite,
    edit: actionCopyEs.edit,
    openStudyAria: "Abrir el estudio",
    inviteStudyAria: "Invitar a clínicos a este estudio",
    editStudyAria: "Modificar el estudio",
    openTrackingAria: "Abrir los gráficos de evolución del estudio",
    trackingDialogTitle: (studyName: string) => `Evolución · ${studyName}`,
    emptyLabel: " - ",
    templateCount: (count: number) => `${count} ${count === 1 ? "modelo" : "modelos"}`,
    newStudyTitle: "Nuevo estudio",
    newStudyDescription:
        "Elija los modelos para obtener los accesos a eventos, formularios y calendarios y, a continuación, personalice los permisos, la facturación y los ajustes de publicación.",
    editStudyTitle: "Modificar el estudio",
    editStudyDescription:
        "Actualice los modelos, los accesos obtenidos, los permisos personalizados, la facturación y la visibilidad de este estudio para los responsables.",
    studySaved: "Estudio guardado",
    failedToSaveStudy: "No se ha podido guardar el estudio",
    saveStudy: "Guardar el estudio",
    saveChanges: "Guardar los cambios",
    studyName: "Nombre del estudio",
    studyNamePlaceholder: "p. ej. Elite Tendon Knee 2026",
    studyDescription: "Descripción (opcional)",
    studyDescriptionHint: "Los clínicos verán esto al abrir un enlace de invitación al estudio.",
    studyDescriptionPlaceholder:
        "p. ej., Un registro multicéntrico que sigue los resultados tras la reparación de tendones de rodilla.",
    labelAccess: "Acceso por etiqueta",
    selectLabels: "Seleccionar etiquetas",
    addLabel: "Añadir una etiqueta",
    labelName: "Nombre de la etiqueta",
    labelNamePlaceholder: "p. ej. Elite Tendon Knee",
    formAccess: "Acceso a los formularios",
    selectForms: "Seleccionar formularios",
    templates: "Modelos",
    inferredAccessTitle: "Accesos obtenidos de los modelos",
    inferredAccessDescription:
        "Los cuestionarios, los calendarios y los eventos que requieren los modelos seleccionados se conceden automáticamente.",
    inferredAccessEmpty: "Seleccione uno o más modelos para obtener los accesos de los clínicos.",
    inferredEvents: "Eventos",
    inferredForms: "Cuestionarios",
    inferredSchedules: "Calendarios",
    inferredNone: "Ninguno",
    customiseAccessTitle: "Personalizar los accesos",
    customiseAccessHideTitle: "Ocultar las opciones de acceso",
    customiseAccessDescription:
        "Control total de los modos y de los permisos privados. Los cuestionarios, los calendarios y los eventos que requieren los modelos permanecen seleccionados.",
    loadingAccessOptions: "Cargando las opciones de acceso…",
    billingPlan: "Plan de facturación",
    selectPlan: "Seleccionar un plan",
    expiryDate: "Fecha de vencimiento",
    pickDate: "DD/MM/AAAA",
    expiryDateMinMessage: "El vencimiento debe ser mañana o posterior",
    expiryDateMaxMessage: "Nos mantenemos dentro de los próximos 100 años",
    expiryDateInvalidMessage: "Esta fecha no parece correcta",
    publishStudyForManagers: "Publicar el estudio",
    labelAccessSummary: "Acceso por etiqueta",
    formAccessSummary: "Acceso a los formularios",
    templatesSummary: "Modelos",
    billingPlanSummary: "Plan de facturación",
    expirySummary: "Vencimiento",
    statusSummary: "Estado",
    loadingStudy: "Cargando el estudio…",
    studyNotFound: "Estudio no encontrado",
    backToStudies: "Volver a los estudios",
    studyInvite: "Invitación al estudio",
    inviteToStudy: (studyName: string) => `Invitar al estudio ${studyName}`,
    inviteToStudyDescription:
        "Comparta un código QR o un enlace para que los clínicos puedan registrarse y unirse a este estudio. Si lo desea, puede imponer una organización y una especialidad.",
    inviteStepReview: "Revisión",
    inviteStepEmail: "Correo electrónico",
    inviteStepQr: "Código QR",
    inviteStepInvite: "Invitación",
    generatingInviteLink: "Generando el enlace de invitación…",
    failedToCreateInviteLink: "No se ha podido crear el enlace de invitación",
    studyInviteQrDescription: (studyName: string) =>
        `Comparta un código QR o un enlace para que los clínicos puedan registrarse y unirse a ${studyName}. La organización y la especialidad proceden de los valores predeterminados del estudio.`,
    joinStudyTitle: (studyName: string) => `Unirse a ${studyName}`,
    optionalOrganisationSignupHint:
        "Opcional. Déjelo vacío para que el clínico cree su propia organización durante la configuración inicial.",
    clinicianWillChooseOrganisation: "El clínico elegirá o creará su propia organización en el momento del registro.",
    specialty: "Especialidad",
    optionalSuffix: "(opcional)",
    optionalSpecialtySignupHint:
        "Opcional. Si se indica, la especialidad se aplica a los clínicos que se unen a este estudio.",
    selectSpecialtyPlaceholder: "Seleccionar una especialidad",
    clearSpecialty: "Borrar",
    clinicianInviteDefaultsTitle: "Valores predeterminados de la invitación de los clínicos",
    clinicianInviteDefaultsDescription:
        "Puede imponer una organización y una especialidad a los clínicos que se unen a este estudio mediante un código QR o un enlace de invitación.",
    defaultOrganisation: "Organización",
    noOrganisationsAvailable: "No hay ninguna organización disponible para seleccionar.",
    inviteDefaultsSummary: (summary: string) => `Valores predeterminados de la invitación: ${summary}`,
    inviteDefaultsEmpty:
        "No hay ninguna organización ni especialidad impuesta para este estudio. Los clínicos las indican durante la configuración inicial.",
    emailRequired: "La dirección de correo electrónico es obligatoria",
    validEmailRequired: "Introduzca una dirección de correo electrónico válida",
    studyInviteEmailSent: "Correo de invitación al estudio enviado",
    failedToSendInvite: "No se ha podido enviar la invitación",
    trackingTitle: "Seguimiento del estudio",
    trackingDescription:
        "Clínicos de este estudio, los diarios que han creado y quienes están vinculados pero aún no forman parte.",
    trackingLabelsHint: "Etiquetas",
    trackingLoading: "Cargando el seguimiento…",
    trackingError: "No se ha podido cargar el seguimiento del estudio.",
    trackingNoLabels: "Añada etiquetas a este estudio para hacer el seguimiento de los clínicos y los diarios.",
    trackingNoClinicians: "Ningún clínico tiene todavía estas etiquetas.",
    trackingNoDiaries: "Todavía no se ha etiquetado ningún diario para este estudio.",
    trackingTotalDiaries: "Diarios",
    trackingAvgDiariesPerClinician: "Media de diarios / clínico",
    trackingCliniciansWithDiaries: "Clínicos con diarios",
    trackingDiariesPerClinician: "Diarios por clínico",
    trackingCumulativeDiaries: "Diarios acumulados",
    trackingColumnMember: "Miembro",
    trackingColumnDiaries: "Diarios",
    trackingColumnRole: "Rol",
    trackingColumnTemplates: "Plantillas",
    trackingColumnTrend: "Diarios a lo largo del tiempo",
    trackingColumnLastDiary: "Último diario",
    trackingLastDiaryNone: "Ninguno",
    trackingTemplatesFromStudy: (count: number) => `${count} del estudio`,
    trackingRoleLabels: {
        ADMIN: "Admin",
        MANAGER: "Responsable",
        CLINICIAN: "Clínico",
        SECRETARY: "Secretaría",
        VALIDATOR: "Validador",
    },
    trackingAddToStudy: "Añadir al estudio",
    trackingRemoveFromStudy: "Quitar del estudio",
    trackingAddAllToStudy: "Añadir todos al estudio",
    trackingCliniciansInStudy: "En el estudio",
    trackingCliniciansInStudyHint: (total: number) => `de ${total} ${total === 1 ? "clínico" : "clínicos"}`,
    trackingStatusNotInStudy: "No está en el estudio",
    trackingReasonHasLabels: "Tiene las etiquetas del estudio",
    trackingReasonHasDiaries: "Ha creado diarios del estudio",
    trackingNotInStudyCallout: (count: number) =>
        `${count} ${count === 1 ? "clínico vinculado al estudio aún no forma" : "clínicos vinculados al estudio aún no forman"} parte de él. Al añadirlos, recibirán sus etiquetas, cuestionarios y plantillas.`,
    trackingRowActions: (name: string) => `Acciones para ${name}`,
    trackingRemoveConfirmTitle: (name: string) => `¿Quitar a ${name} del estudio?`,
    trackingRemoveConfirmDescription:
        "Perderá las etiquetas, cuestionarios y plantillas del estudio. Sus diarios no cambian y se mantiene todo lo que se haya compartido directamente.",
    trackingCancel: "Cancelar",
    trackingCliniciansShort: "clínicos",
    trackingNoLabelsShort: "Ninguna etiqueta",
    trackingNoDiariesShort: "Ningún diario por el momento",
};
